/**
 * 支付相关 及 产品升级方案采购相关
 */

import { API_TYPE } from '@umu/umu-fetch';

export const PaymentAPI = {
    /**
     * 获取付款记录
     */
    GET_PAYMENT_HISTORY_LIST: {
        url: '/uapi/v1/payment/paid-list',
        type: API_TYPE.GET,
    },

    /**
     * 申请发票
     */
    APPLY_PAYMENT_INVOICE: {
        url: '/uapi/v1/payment/apply-invoice',
        type: API_TYPE.POST,
    },

    /**
     * 获取版本商品列表
     */
    GET_PLAN_PACKAGE: {
        url: '/uapi/v1/commodity/account-plan-package-list',
        type: API_TYPE.GET,
    },

    /**
     * 获取商业版的订单总额
     */
    GET_COMMERICAL_ORDER_AMOINT: {
        url: '/uapi/v1/commodity/business-order-amount',
        type: API_TYPE.GET,
    },

    /**
     * 获取当前用户的账号版本信息
     */
    GET_ACCOUNT_PLAN: {
        url: '/uapi/v1/user/account-plan',
        type: API_TYPE.GET,
    },

    /**
     * 创建订单
     */
    PAYMENT_CREATE_ORDER: {
        url: '/uapi/v1/payment/create-order',
        type: API_TYPE.POST,
    },

    /**
     * 发起支付
     */
    PAYMENT_CREATE_PAY: {
        url: '/uapi/v1/payment/create-pay',
        type: API_TYPE.POST,
    },

    /**
     * 查询支付状态
     */
    PAYMENT_QUERY_ORDER: {
        url: '/uapi/v1/payment/query-order',
        type: API_TYPE.GET,
    },

    /**
     * 联系销售
     */
    CONTACT_SALES: {
        url: '/uapi/v1/commodity/contact-sales',
        type: API_TYPE.POST,
    },

    /**
     * 申请商用版试用
     */
    APPLY_FOR_COMMERICAL_TRIAL: {
        url: '/uapi/v1/commodity/business-trial',
        type: API_TYPE.GET,
    },

    /**
     * 支付用户行为打点
     */
    USER_PAYMENT_EVENT: {
        url: '/uapi/v2/stat/view-log',
        type: API_TYPE.GET,
    },

    /**
     * 获取点数余额与状态
     */
    GET_BALANCE: {
        url: '/uapi/v1/umupoints/balance',
        type: API_TYPE.GET,
    },
    /**
     * 定价页价格
     */
    GET_PLAN_PRICING: {
        url: '/uapi/v1/commodity/account-plan-surface-list',
        type: API_TYPE.POST,
    },
};
